module.exports = __webpack_public_path__ + "static/media/auth_icon.edc9ce71.svg";